/** @module Auth0StateHelper */
/* eslint-disable import/extensions */
import Auth0Constants from './auth0-constants.mjs';
import CookieHelper from './auth0-cookie-helper.mjs';
import Auth0LocalStorageHelper from './auth0-local-storage-helper.mjs';

class Auth0StateHelper {
  static resetAuthState = (resetOptions = {
    resetAuthCookieState: true,
    resetMessagingCookieState: false,
    resetLocalStorageState: false,

  }) => {
    console.log('Auth0StateHelper.resetAuthState => start');
    let cookieList = [];
    if (resetOptions.resetAuthCookieState) {
      cookieList = Auth0Constants.AUTH0_STATE_COOKIES;
    }
    if (resetOptions.resetAuthCookieState) {
      cookieList = [
        ...cookieList,
        ...Auth0Constants.AUTH0_MESSAGING_STATE_COOKIES,
      ];
    }
    console.log('Auth0StateHelper.resetAuthState => deleting cookies', cookieList);
    CookieHelper.deleteCookies(cookieList);

    if (resetOptions.resetLocalStorageState) {
      console.log('Auth0StateHelper.resetAuthState => deleting local storage');
      Auth0LocalStorageHelper.resetAuth0State();
    }
    console.log('Auth0StateHelper.resetAuthState => end');
  };
}

export default Auth0StateHelper;
